interface Props {
  error?: string;
  checking?: boolean;
  forgot_pin?: boolean;
  confirm_reset_pin?: boolean;
  prompt_reset_pin?: boolean;
}

export const getLockScreenTitle = (state: Props) => {
  if (state.error) {
    return state.error;
  }

  if (state.checking) {
    return 'Checking your PIN...';
  }

  if (state.forgot_pin) {
    return 'Check your email for a temporary PIN and enter it here';
  }

  if (state.confirm_reset_pin) {
    return 'Enter the PIN again to confirm';
  }

  if (state.prompt_reset_pin) {
    return 'Enter a new PIN';
  }

  return 'Enter pincode';
};
